import { marketingApi } from '@/api/MarketingApi'
import Config from '@/config'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

export const useFetchPatientReferral = () => {
	const { data, isLoading, isError } = useQuery({
		queryKey: ['fetch-patient-referral'],
		queryFn: () => marketingApi.fetchPatientReferral(),
	})

	const referralUrl = useMemo(() => {
		if (!data || !data.referralCode) {
			return ''
		}

		return `${Config.JOIN_URL}?code=${data.referralCode}&utm_source=app_referral`
	}, [data])

	const hasRenderableReferral = useMemo(() => {
		return !isLoading && !!referralUrl
	}, [isLoading, referralUrl])

	return {
		referralUrl,
		/** The code on its own, for a screen that would rather show that than a URL. */
		referralCode: data?.referralCode,
		discountInCents: data?.discountInCents,
		isLoading,
		isError,
		hasRenderableReferral,
	}
}
